import { atom } from "jotai";

export const answeredState = atom([]);
